module.exports = __webpack_public_path__ + "01b0d06269b15180838b881d249374bd.MP3";